import { Validator, Validators, AbstractControl } from "@angular/forms";
import { isValidCpfCnpj } from "@app-utils/document-utils";

export class BCrowValidators {
  static isValidCpf(control: AbstractControl): Validators {
    if (control.value) {
      const cpf = control.value.replace(/\D/g, "");
      let numbers;
      let digits;
      let sum;
      let i;
      let result;
      let equalDigits;

      equalDigits = 1;
      if (cpf.length < 11) {
        return { cpf: true };
      }

      for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
          equalDigits = 0;
          break;
        }
      }

      if (!equalDigits) {
        numbers = cpf.substring(0, 9);
        digits = cpf.substring(9);
        sum = 0;
        for (i = 10; i > 1; i--) {
          sum += numbers.charAt(10 - i) * i;
        }

        result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

        if (result !== Number(digits.charAt(0))) {
          return { cpf: true };
        }
        numbers = cpf.substring(0, 10);
        sum = 0;

        for (i = 11; i > 1; i--) {
          sum += numbers.charAt(11 - i) * i;
        }
        result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

        if (result !== Number(digits.charAt(1))) {
          return { cpf: true };
        }
        return null;
      } else {
        return { cpf: true };
      }
    }
    return null;
  }

  static validAutocompleteMatch(control: AbstractControl) {
    const selection: any = control.value;
    if (typeof selection === "string") {
      return { required: true };
    }
    return null;
  }

  static validCEP(control: AbstractControl) {
    let v: string = control.value;
    if (v == null || v == "") {
      return null;
    }
    v = clearAllSpecialChar(v);
    if (v.length >= 8) {
      return null;
    } else {
      return { invalidCep: true };
    }
  }

  static validatorCpfCnpj(currentControl: AbstractControl): Validators {
    const a = String(currentControl.value);
    if (a === undefined || a === 'undefined' || clearValue(a).length === 0) {
      return null;
    }

    if (isValidCpfCnpj(a)) {
      return null;
    }

    return {
      cpf: true
    };

  }
}
const clearAllSpecialChar = (a: string) => {
  return a.replace(/[^\w\s]/gi, "");
};

const clearValue = (a: string) => {
  return String(a).replace(/[^\w\s]/gi, '');
}
